import { useTranslation } from 'react-i18next'
import { KibTopLevelAlert } from '@chewy/kib-messaging-react'

import type { PaymentRequestSendErrorKind } from '../constants/paymentRequestDialogV2Constants'

import '@chewy/kib-messaging-styles/dist/styles/kib-alert-icon.css'
import '@chewy/kib-messaging-styles/dist/styles/kib-top-level-alert.css'
import styles from './PaymentRequestSendErrorBanner.module.scss'

interface PaymentRequestSendErrorBannerProps {
  errorKind: PaymentRequestSendErrorKind
  onDismiss: () => void
}

export const PaymentRequestSendErrorBanner = ({
  errorKind,
  onDismiss,
}: PaymentRequestSendErrorBannerProps) => {
  const { t } = useTranslation('Dialogs')
  const bannerProp: Record<
    PaymentRequestSendErrorKind,
    { heading: string; message: string }
  > = {
    MESSAGE_DIDNT_SEND: {
      heading: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.MESSAGE_DIDNT_SEND.HEADING',
      ),
      message: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.MESSAGE_DIDNT_SEND.MESSAGE',
      ),
    },
    MESSAGE_CANT_BE_SEND: {
      heading: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.MESSAGE_CANT_BE_SEND.HEADING',
      ),
      message: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.MESSAGE_CANT_BE_SEND.MESSAGE',
      ),
    },
    TEMPLATE_COULDNT_BE_CREATED: {
      heading: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.TEMPLATE_COULDNT_BE_CREATED.HEADING',
      ),
      message: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.TEMPLATE_COULDNT_BE_CREATED.MESSAGE',
      ),
    },
    CONNECTION_ISSUE: {
      heading: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.CONNECTION_ISSUE.HEADING',
      ),
      message: t(
        'Dialogs:PAYMENT_REQUEST_DIALOG_V2.ERRORS.CONNECTION_ISSUE.MESSAGE',
      ),
    },
  }

  const { heading, message } = bannerProp[errorKind]
  return (
    <div className={styles.paymentRequestSendErrorBanner}>
      <KibTopLevelAlert
        dismissible
        heading={heading}
        severity="error"
        onDismiss={onDismiss}
      >
        {message}
      </KibTopLevelAlert>
    </div>
  )
}
